import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { EdgePatientEnrollmentApi, SurveyV3Api } from '@trialcard/apigateway.client';

import {
    EnrollPatientRequestModel,
    EnterpriseCoordinatorAccountUpsearchRequestModel,
    UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
    UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
    EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
} from '@trialcard/apigateway.models';
import { AxiosError, AxiosResponse } from 'axios';
import { OnClear } from '~/services/clearModule';
import { Settings } from '~/services/settings';
import PatientModule from '~/store/patient';

@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {
    @Resolve
    public enrollmentApi!: EdgePatientEnrollmentApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    public surveyAPI!: SurveyV3Api;

    @Resolve
    public patient!: PatientModule;

    @Mutation
    public updateSurveySessionId(newId: number) {
        this.surveySessionId = newId;
    }

    alternativeEnrollment: boolean | null = null;

    surveySessionId = 0;

    memberNumber: string | null = '55526565010';

    @Mutation
    public setMemberNumber(memberNumber: string) {
        this.memberNumber = memberNumber;
    }

    @Action({ rawError: true })
    public async submitToAPI() {
        let response = null;
        const { firstName, lastName, dateOfBirth, gender, addresses, phoneNumbers, emailAddresses } = this.patient.patientInformation;
        try {
            const patient = {
                account: {
                    patientData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            firstName,
                            lastName,
                            dateOfBirth,
                            // gender,
                            addresses,
                            phoneNumbers,
                            emailAddresses,
                            middleName: '',
                            suffix: '',
                            nickname: '',
                        } as EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    } as UpsearchModelEnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel,
                    accountData: {
                        canUpdate: true,
                        canInsert: true,
                        skipSearch: false,
                        model: {
                            accountType: 1,
                        },
                    } as UpsearchModelEnterpriseCoordinatorAccountServiceModelsAccountUpsearchModel,
                    surveySessionData: [this.alternativeEnrollment ? null : this.surveySessionId] as number[],
                } as EnterpriseCoordinatorAccountUpsearchRequestModel,
            } as EnrollPatientRequestModel;
            response = await this.enrollmentApi.patientEnrollmentEnrollPatient(patient, this.settings.programId);
        } catch {
            response = { status: 400 } as AxiosResponse;
        }
        return response;
    }

    @Action({ rawError: true })
    public async fetchSurveySession() {
        let surveyError = false;
        try {
            const surveySessionResponse = await this.surveyAPI.surveySessionCreate0({ surveyId: Number(this.settings.surveyId) });
            const surveyId = surveySessionResponse.data.data!.surveySessionId;
            const fullSurveySessionResponse = await this.surveyAPI.fullSurveySessionCreate0({
                sessionValues: [
                    {
                        surveySessionId: surveyId,
                        questionId: Number(this.settings.cardTypeQuestionId),
                        answerId: Number(this.settings.cardTypeAnswerId),
                    },
                ],
            });

            this.updateSurveySessionId(Number(surveyId));
        } catch (error) {
            console.error(error);
            surveyError = true;
            // TODO: Navigate to error
        }
        return surveyError;
    }
}
